'use client'

import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const Wrapper = styled.div``

export const StyledBreadCrumb = styled.div`
  display: none;
  
  padding-top: 5px;
  padding-bottom: 5px;

  & .ant-btn {
    white-space: normal;
  }

  &.ant-breadcrumb {
    line-height: unset;
  }
  
  & .ant-breadcrumb-link,
  & .ant-space-item {
    font-size: 1rem;
    display: fle;
    align-items: baseline;
    position: relative;
  }

  & a.ant-breadcrumb-link span {
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.5);
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: 0.5em;
    }
  }

  [data-dark='true'] & {
    .ant-breadcrumb-link,
    .ant-breadcrumb a,
    a,
    span {
      color: ${theme.colors.textDark};
    }

    a.ant-breadcrumb-link {
      span {
        &:after {
          border-bottom-color: ${theme.colors.textDark};
        }
      }
    }

    .ant-space-item svg {
      stroke: ${theme.colors.textDark};
    }

    .ant-breadcrumb-separator {
      color: ${theme.colors.textDark};
    }
  }

  & ol {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  & ol li {
    display: flex;
    align-items: center;

    .ant-btn {
      white-space: nowrap;

      * {
        white-space: nowrap;
      }
    }
  }
  
  @media ${media.md} {
    display: flex;
  }
`

export const StyledBreadCrumbText = styled.div`
  cursor: default;

  height: unset;
  margin: unset;
  line-height: unset;
  
  padding: 0;
  padding-left: 4px;
  padding-right: 4px;
`

export const MobileBreadcrumbs = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media ${media.md} {
    display: none;
  }
`

export const MobileBreadcrumb = styled.div`
  & span {
    font-size: 1.1rem;
  }

  main[data-dark='true'] & {
    span,
    svg {
      color: white;
    }
  }
`
